import styles from "./styles.module.scss";
import { ProductTable } from "../ProductTable";

export const ProductSelection = ({
  gRForm,
  setGRForm = () => {},
  ...validationParams
}) => {
  return (
    <div className={styles.productSelection}>
      <ProductTable
        gRForm={gRForm}
        setGRForm={setGRForm}
        {...validationParams}
      />
    </div>
  );
};
